import type { CSSProperties, ReactNode } from "react";

import styles from "./Pill.module.css";
import type { TaskStatus } from "../data/types";
import { cx } from "../lib/cx";

export type PillProps = {
  readonly children: ReactNode;
  readonly className?: string;
  readonly dotColor?: string;
  readonly status?: TaskStatus;
  readonly style?: CSSProperties;
  readonly title?: string;
};

export const Pill = ({
  children,
  className,
  dotColor,
  status,
  style,
  title,
}: PillProps) => (
  <span
    className={cx(styles.pill, className)}
    data-status={status}
    style={style}
    title={title}
  >
    <span
      className={styles.dot}
      style={dotColor ? { background: dotColor } : undefined}
    />
    {children}
  </span>
);
